import { render, staticRenderFns } from "./MyScrollRankingBoard.vue?vue&type=template&id=fa16ad8a&"
import script from "./MyScrollRankingBoard.vue?vue&type=script&lang=js&"
export * from "./MyScrollRankingBoard.vue?vue&type=script&lang=js&"
import style0 from "./MyScrollRankingBoard.vue?vue&type=style&index=0&id=fa16ad8a&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports